/**
 * Tasty Tracks API.
 *
 * Thin wrappers around the shared api client. Auth (access token + refresh
 * retry) is handled by client.js — we just name the endpoints here.
 */

import { api } from './client.js';


// ─── public reads ──────────────────────────────────────────────────────────

export const getTracksHome   = ()   => api.get('/api/tracks');
export const getCurrentTrack = ()   => api.get('/api/tracks/current');
export const getTrack        = (id) => api.get(`/api/tracks/${id}`);
export const getArchive      = (page = 1, pageSize = 24) =>
  api.get(`/api/tracks/archive?page=${page}&page_size=${pageSize}`);


// ─── comments ──────────────────────────────────────────────────────────────

export const listComments  = (trackId)         => api.get(`/api/tracks/${trackId}/comments`);
export const createComment = (trackId, body)   => api.post(`/api/tracks/${trackId}/comments`, { body });
export const updateComment = (commentId, body) => api.patch(`/api/comments/${commentId}`, { body });
export const deleteComment = (commentId)       => api.del(`/api/comments/${commentId}`);


// ─── reactions ─────────────────────────────────────────────────────────────

export const listReactionTypes = ()                  => api.get('/api/reaction-types');
export const getTrackReactions = (trackId)           => api.get(`/api/tracks/${trackId}/reactions`);
export const reactToTrack      = (trackId, emoji)    => api.post(`/api/tracks/${trackId}/reactions`, { emoji });
export const reactToComment    = (commentId, emoji)  => api.post(`/api/comments/${commentId}/reactions`, { emoji });


// ─── admin ─────────────────────────────────────────────────────────────────

export const previewTrack       = (youtube_url) => api.post('/api/tracks/preview', { youtube_url });
export const createTrack        = (payload)     => api.post('/api/tracks', payload);
export const updateTrack        = (id, payload) => api.patch(`/api/tracks/${id}`, payload);
export const setCurrentTrack    = (id)          => api.post(`/api/tracks/${id}/set-current`);
export const deleteTrack        = (id, hard = false) =>
  api.del(`/api/tracks/${id}${hard ? '?hard=true' : ''}`);
export const listAllTracksAdmin = (includeArchived = true) =>
  api.get(`/api/tracks/admin/all?include_archived=${includeArchived}`);
